module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Black.c153faca.woff";